export const iconFontAwesomePunctuationSymbolsQuoteRight = (
	<i className="fa-solid fa-quote-right"></i>
);
